import { useEffect, useState } from "react";
import { Building2, CheckCircle2, Ban, CalendarDays, Users, MessageSquare, BarChart3, Star, FileText } from "lucide-react";
import api from "@/lib/apiClient";
import { PageHeader, StatCard } from "@/components/dashboard/primitives";
import { Skeleton } from "@/components/ui/skeleton";

export default function SuperAdminHome() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/super-admin/stats").then(({ data }) => setStats(data)).catch(() => setStats({})); }, []);

  return (
    <div className="p-5 sm:p-8 max-w-6xl">
      <PageHeader title="Platform overview" subtitle="Aggregate metrics across all organisations." />
      {!stats ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">{Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="h-28 rounded-xl" />)}</div>
      ) : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            <StatCard icon={Building2} label="Total organisations" value={stats.total_organisations ?? 0} accent />
            <StatCard icon={CheckCircle2} label="Active" value={stats.active_organisations ?? 0} />
            <StatCard icon={Ban} label="Suspended" value={stats.suspended_organisations ?? 0} />
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <StatCard icon={Users} label="Total users" value={stats.total_users ?? 0} />
            <StatCard icon={CalendarDays} label="Total events" value={stats.total_events ?? 0} />
            <StatCard icon={Users} label="Total attendees" value={stats.total_attendees ?? 0} />
            <StatCard icon={MessageSquare} label="Questions" value={stats.total_questions ?? 0} />
            <StatCard icon={BarChart3} label="Poll responses" value={stats.total_poll_responses ?? 0} />
            <StatCard icon={Star} label="Feedback responses" value={stats.total_feedback ?? 0} />
            <StatCard icon={FileText} label="AI reports" value={stats.total_reports ?? 0} accent />
          </div>

          <div className="mt-8">
            <h2 className="font-display text-lg font-bold text-foreground mb-4">Platform activity</h2>
            <div className="rounded-xl border border-border bg-card divide-y divide-border max-h-96 overflow-y-auto">
              {stats.recent_activity?.length ? stats.recent_activity.map((a) => (
                <div key={a.id} className="flex items-center justify-between p-3.5 text-sm">
                  <span className="text-foreground"><span className="font-medium">{a.user_name || "System"}</span> <span className="text-muted-foreground">{a.action?.replace(/[._]/g, " ")}</span></span>
                  <span className="text-xs text-muted-foreground">{a.created_at ? new Date(a.created_at).toLocaleString() : ""}</span>
                </div>
              )) : <p className="p-4 text-sm text-muted-foreground">No activity yet.</p>}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
